import { MDBAlert, MDBBtn, MDBIcon } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import Select from 'react-select'

export default class ColaboradorFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombres: "",
                apellidos: "",
                direccion: "",
                nit: "",
                numero_empleado: 0,
                dpi: 0,
                numero_tel: 0,
                mail_personal: "",
                mail_institucional: "",
                titulo: "",
                fecha_ingreso: "",
                fecha_contratacion: "",
                fecha_despido: "",
                estado: true,
                escolaridad: 0,
                puesto: 0,
                empresa: 0,
                defaultDeptoAreas: 0
            },
            colapsar: true,
            colapsarAsociarDepartamentoArea: true,
            colapsarAsociarUbicacion: true,
            puestoVista: undefined,
            camposRequeridos: [],
            escolaridades: [],
            puestos: [],
            empresas: [],
            ubicaciones: [],
            ubicacionesAsociados: [],
            departamentoAreas: [],
            departamentoAreaAsociados: []
        };
    }

    componentDidMount() {
        this.obtenerEscolaridades();
        this.obtenerPuestos();
        this.obtenerEmpresas();
        this.obtenerDepartamentoAreas();
        this.obtenerUbicaciones();
        this.obtenerDepartamentoAreasAsociados();
        this.obtenerUbicacionesAsociados();
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    colapsarAsociarDepartamentoArea() {
        this.setState(estadoAnterior => ({ colapsarAsociarDepartamentoArea: !estadoAnterior.colapsarAsociarDepartamentoArea }));
    }

    colapsarAsociarUbicacion() {
        this.setState(estadoAnterior => ({ colapsarAsociarUbicacion: !estadoAnterior.colapsarAsociarUbicacion }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    actualizaValoresEnPantalla = (datos) => {
        if (_valid(datos)) {
            this.setState({ puestoVista: datos });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['puesto']: datos.value }
            }));
        } else {
            this.setState({ puestoVista: datos });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['puesto']: undefined }
            }));
        }
    }

    asociarDepartamentoArea = (target) => {
        if (_valid(target)) {
            const registro = this.state.registro
            const datos = {
                default: false,
                colaborador: registro.id,
                departamento_area: target.value,
                asignar_solicitud: (target.value == 41) ? 0 : 1
            }
            this.apiRest.post('/asociarColaboradorDeptoArea', datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Departamento / Area asociado exitosamente!');
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensajeError);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }

                this.obtenerDepartamentoAreasAsociados();
            });
        }
    }

    actualizarDefaultDepartamentoArea = ({ target: { value } }) => {
        const registro = this.state.registro
        const datos = {
            id: value,
            colaborador: registro.id
        }
        this.apiRest.put('/actualizarDefaultColaboradorDeptoArea', datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Departamento / Area actualizado exitosamente!');
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }

            this.obtenerDepartamentoAreasAsociados();
        });
    }

    eliminarDepartamentoAreaAsociado = idColaboradorDepartamentoArea => {
        this.apiRest.delete('/eliminarColaboradorDeptoArea/' + idColaboradorDepartamentoArea).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Departamento / Area eliminado exitosamente!');
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }

            this.obtenerDepartamentoAreasAsociados();
        });
    }

    obtenerDepartamentoAreasAsociados() {
        const registro = this.state.registro;
        if (_valid(registro.id)) {
            this.apiRest.get('/colaboradorDeptoAreas/' + registro.id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentoAreaAsociados: resultado.data });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    asociarUbicacion = (target) => {
        const registro = this.state.registro
        if (_valid(target)) {
            
            const datos = {
                default: false,
                colaborador: registro.id,
                ubicacion: target.value
            }
            this.apiRest.post('/asociarColaboradorUbicacion', datos).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Ubicacion asociado exitosamente!');
                } else if (resultado.response.status === 400) {
                    toastr.error(resultado.data.mensajeError);
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }

                this.obtenerUbicacionesAsociados();
            });
        }
    }

    actualizarDefaultUbicacion = ({ target: { value } }) => {
        const registro = this.state.registro
        const datos = {
            id: value,
            colaborador: registro.id
        }
        this.apiRest.put('/actualizarDefaultColaboradorUbicacion', datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Ubicacion actualizado exitosamente!');
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }

            this.obtenerUbicacionesAsociados();
        });
    }

    eliminarUbicacionAsociado = idColaboradorUbicacion => {
        this.apiRest.delete('/eliminarColaboradorUbicacion/' + idColaboradorUbicacion).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Ubicacion eliminado exitosamente!');
            } else if (resultado.response.status === 400) {
                toastr.error(resultado.data.mensajeError);
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }

            this.obtenerUbicacionesAsociados();
        });
    }

    obtenerUbicacionesAsociados() {
        const registro = this.state.registro;
        if (_valid(registro.id)) {
            this.apiRest.get('/colaboradorUbicaciones/' + registro.id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicacionesAsociados: resultado.data });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    obtenerEscolaridades() {
        this.apiRest.get('/escolaridad').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ escolaridades: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerPuestos() {
        this.apiRest.get('/puesto').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ puestos: this.formatoSelectPuestos(resultado) });
                const registro = this.state.registro;
                if (_valid(registro.puesto)) {
                    this.apiRest.get('/puesto/' + registro.puesto).then(respuesta => {
                        if (respuesta.exitoso) {
                            let puesto = {
                                'value': respuesta.data.id,
                                'label': respuesta.data.nombre
                            }
                            this.actualizaValoresEnPantalla(puesto);
                        }
                    });
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerEmpresas() {
        this.apiRest.get('/empresa').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ empresas: resultado.data });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerUbicaciones() {
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoSelector(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoSelector = valores => valores.data.map(i => ({ value: i.id, label: 'Empresa: ' + i.empresa_nombre + ' -> Ubicación: ' + i.nombre }));

    obtenerDepartamentoAreas() {
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentoAreas: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: 'Empresa: ' + i.empresa_nombre + ' -> ' + (i.tipo === 1 ? ('Departamento: ' + i.nombre) : ('Departamento: ' + i.padre_nombre + ' -> Area: ' + i.nombre)) }));
    formatoSelectPuestos = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    almacenarRegistro = () => {
        if (this.datosRegistroValidos()) {
            const registro = this.state.registro

            if (registro.fecha_despido === "") {
                registro.fecha_despido = undefined;
            }
            if (_valid(registro.id)) {
                this.apiRest.put('/colaborador/' + registro.id, registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.colapsarAsociarDepartamentoArea();
                        this.colapsarAsociarUbicacion();
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.apiRest.post('/colaborador', registro).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        this.colapsarAsociarDepartamentoArea();
                        this.colapsarAsociarUbicacion();
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const {
            nombres,
            nit,
            dpi,
            apellidos,
            direccion,
            numero_empleado,
            numero_tel,
            empresa,
            puesto,
            escolaridad,
            fecha_contratacion,
            fecha_ingreso
        } = this.state.registro;

        let contador = 0;
        const { camposRequeridos } = this.state;
        if (_valid(nombres)) {
            contador += 1;
        } else {
            camposRequeridos.push("Nombres");
        }
        if (_valid(apellidos)) {
            contador += 1;
        } else {
            camposRequeridos.push("Apellidos");
        }
        if (_valid(direccion)) {
            contador += 1;
        } else {
            camposRequeridos.push("Direccion");
        }
        if (_valid(numero_empleado)) {
            contador += 1;
        } else {
            camposRequeridos.push("Numero de empleado");
        }
        if (_valid(numero_tel)) {
            contador += 1;
        } else {
            camposRequeridos.push("Numero tel");
        }
        if (_valid(empresa)) {
            contador += 1;
        } else {
            camposRequeridos.push("Empresa");
        }
        if (_valid(puesto)) {
            contador += 1;
        } else {
            camposRequeridos.push("Puesto");
        }
        if (_valid(escolaridad)) {
            contador += 1;
        } else {
            camposRequeridos.push("Escolaridad");
        }
        if (_valid(fecha_contratacion)) {
            contador += 1;
        } else {
            camposRequeridos.push("Fecha Contratacion");
        }
        if (_valid(fecha_ingreso)) {
            contador += 1;
        } else {
            camposRequeridos.push("Fecha Ingreso");
        }
        if (_valid(dpi)) {
            contador += 1;
        } else {
            camposRequeridos.push("dpi");
        }
        if (_valid(nit)) {
            contador += 1;
        } else {
            camposRequeridos.push("nit");
        }

        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 12) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { registro, colapsar, colapsarAsociarDepartamentoArea, colapsarAsociarUbicacion, camposRequeridos, departamentoAreas, departamentoAreaAsociados, puestos, puestoVista } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Colaborador" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Colaborador</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombres" className="form-label">
                                                                        Nombres
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombres}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombres"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Nombres"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="apellidos" className="form-label">
                                                                        Apellidos
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.apellidos}
                                                                        onChange={this.actualizarValores}
                                                                        name="apellidos"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Apellidos"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="direccion" className="form-label">
                                                                        Direccion
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.direccion}
                                                                        onChange={this.actualizarValores}
                                                                        name="direccion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Direccion"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="titulo" className="form-label">
                                                                        Titulo
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.titulo}
                                                                        onChange={this.actualizarValores}
                                                                        name="titulo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Titulo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="mail_personal" className="form-label">
                                                                        Mail personal
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.mail_personal}
                                                                        onChange={this.actualizarValores}
                                                                        name="mail_personal"
                                                                        type="mail"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Mail personal"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="mail_institucional" className="form-label">
                                                                        Mail institucional
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.mail_institucional}
                                                                        onChange={this.actualizarValores}
                                                                        name="mail_institucional"
                                                                        type="mail"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Mail institucional"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nit" className="form-label">
                                                                        Nit
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nit}
                                                                        onChange={this.actualizarValores}
                                                                        name="nit"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Nit"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="numero_empleado" className="form-label">
                                                                        Numero de empleado
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.numero_empleado}
                                                                        onChange={this.actualizarValores}
                                                                        name="numero_empleado"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Numero de empleado"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="dpi" className="form-label">
                                                                        Dpi
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.dpi}
                                                                        onChange={this.actualizarValores}
                                                                        name="dpi"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Dpi"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="numero_tel" className="form-label">
                                                                        Numero de telefono
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.numero_tel}
                                                                        onChange={this.actualizarValores}
                                                                        name="numero_tel"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu Numero de telefono"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_ingreso" className="form-label">
                                                                        Fecha ingreso
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_ingreso}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_ingreso"
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu fecha de ingreso"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_contratacion" className="form-label">
                                                                        Fecha contratación
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_contratacion}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_contratacion"
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu fecha de contratación"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_despido" className="form-label">
                                                                        Fecha despido
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_despido}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_despido"
                                                                        type="date"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu fecha de despido"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Escolaridad
                                                                    </Label>
                                                                    <select
                                                                        value={registro.escolaridad}
                                                                        onChange={this.actualizarValores}
                                                                        name="escolaridad"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.escolaridades.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Puesto
                                                                    </Label>
                                                                    <Select
                                                                        value={puestoVista}
                                                                        options={puestos}
                                                                        onChange={this.actualizaValoresEnPantalla}
                                                                        name="puesto"
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Seleccionar"
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay más opciones"}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="ubicacion" className="form-label">
                                                                        Empresa
                                                                    </Label>
                                                                    <select
                                                                        value={registro.empresa}
                                                                        onChange={this.actualizarValores}
                                                                        name="empresa"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="0">Seleccionar</option>
                                                                        {this.state.empresas.map(item => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label">
                                                                        Estado
                                                                    </Label>
                                                                    <select
                                                                        value={registro.estado}
                                                                        onChange={this.actualizarValores}
                                                                        name="estado"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="true">Activo</option>
                                                                        <option value="false">Inactivo</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/colaboradorListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarAsociarDepartamentoArea()} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar Departamento / Area</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarDepartamentoArea}>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div className="mb-3 mb-4">
                                                            <Label htmlFor="ubicacion" className="form-label">
                                                                Agregar Departamento / Área
                                                            </Label>
                                                            <Select
                                                                name="agregarDeptoAreas"
                                                                options={departamentoAreas}
                                                                onChange={this.asociarDepartamentoArea}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Seleccionar"
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Table className="table table-sm m-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Por defecto</th>
                                                            <th>Empresa</th>
                                                            <th>Departamento</th>
                                                            <th>Área</th>
                                                            <th>Quitar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            departamentoAreaAsociados.map(colaboradorDepto =>
                                                                <tr key={colaboradorDepto.id}>
                                                                    <td>
                                                                        <input
                                                                            type="radio"
                                                                            name="asociarDeptoArea"
                                                                            value={colaboradorDepto.id}
                                                                            defaultChecked={colaboradorDepto.default}
                                                                            onChange={this.actualizarDefaultDepartamentoArea}
                                                                        />
                                                                    </td>
                                                                    <td>{colaboradorDepto.departamento_area.empresa_nombre}</td>
                                                                    <td>{_valid(colaboradorDepto.departamento_area.padre) ? colaboradorDepto.departamento_area.padre_nombre : colaboradorDepto.departamento_area.nombre}</td>
                                                                    <td>{colaboradorDepto.departamento_area.tipo === 2 ? colaboradorDepto.departamento_area.nombre : ''}</td>
                                                                    <td>
                                                                        <MDBBtn className="waves-effect" size="sm" color="danger" onClick={() => this.eliminarDepartamentoAreaAsociado(colaboradorDepto.id)}>
                                                                            <MDBIcon icon="fas fa-times" />
                                                                        </MDBBtn>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarAsociarUbicacion()} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar Ubicación</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarUbicacion}>
                                                <Row>
                                                    <Col lg={12}>
                                                        <div className="mb-3 mb-4">
                                                            <Label htmlFor="ubicacion" className="form-label">
                                                                Agregar Ubicación
                                                            </Label>
                                                            <Select
                                                                name="agregarUbicacion"
                                                                options={this.state.ubicaciones}
                                                                onChange={this.asociarUbicacion}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Seleccionar"
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Table className="table table-sm m-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Por defecto</th>
                                                            <th>Empresa</th>
                                                            <th>Ubicación</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.ubicacionesAsociados.map(colaboradorUbicacion =>
                                                                <tr key={colaboradorUbicacion.id}>
                                                                    <td>
                                                                        <input
                                                                            type="radio"
                                                                            name="asociarUbicacion"
                                                                            value={colaboradorUbicacion.id}
                                                                            defaultChecked={colaboradorUbicacion.default}
                                                                            onChange={this.actualizarDefaultUbicacion}
                                                                        />
                                                                    </td>
                                                                    <td>{colaboradorUbicacion.ubicacion.empresa_nombre}</td>
                                                                    <td>{colaboradorUbicacion.ubicacion.nombre}</td>
                                                                    <td>
                                                                        <MDBBtn className="waves-effect" size="sm" color="danger" onClick={() => this.eliminarUbicacionAsociado(colaboradorUbicacion.id)}>
                                                                            <MDBIcon icon="fas fa-times" />
                                                                        </MDBBtn>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}